module.exports = __webpack_public_path__ + "img/MilitaryTabSelected_ua.de79d311.webp";